import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PriorityPicker } from '../../../../components/entity-picker/PriorityPicker';
import { FilterCard } from '../filter-card/FilterCard';

type Props = {
  title: string;
  value: { id: number; name: string }[] | null;
  onChange: (value: { id: number; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const TicketPriorityFilterCard: React.FC<Props> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value?.length) return null;
    if (value.length === 1) return value[0].name;
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <PriorityPicker multiple={true} value={value} onChange={onChange} />
    </FilterCard>
  );
};
